var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ],
      staticClass: "upload-control-wrap"
    },
    [
      _c(
        "el-radio-group",
        {
          staticClass: "upload-type-radio",
          attrs: { size: "small" },
          model: {
            value: _vm.uploadType,
            callback: function($$v) {
              _vm.uploadType = $$v
            },
            expression: "uploadType"
          }
        },
        [
          _c("el-radio", { attrs: { label: "drag", border: "" } }, [
            _vm._v("拖拽上传")
          ]),
          _vm._v(" "),
          _c("el-radio", { attrs: { label: "cropper", border: "" } }, [
            _vm._v("裁剪上传")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.uploadType === "cropper"
        ? _c("cropperUpload", {
            on: { "upload-handler": _vm.cropperUploadHandler }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.uploadType === "drag"
        ? _c("dragUpload", {
            attrs: { hintMsg: _vm.uploadHint, multiple: _vm.multiple },
            on: { "upload-handler": _vm.dragUploadHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78f5affd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f5affd","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/index.vue
// module id = 1226
// module chunks = 7